import React from "react";
import { AlertTriangle } from "lucide-react";

const RED_FLAGS = [
  "Baby less than 3 months with fever ≥38°C",
  "Difficulty breathing, chest retractions, noisy breathing with distress",
  "Blue lips or face",
  "Seizure",
  "Very sleepy, unconscious, floppy, or not responding",
  "Refusing feeds repeatedly",
  "Very low urine output",
  "Severe dehydration",
  "Blood in stool",
  "Green/bilious vomiting",
  "Persistent vomiting",
  "Severe injury or fall",
];

export default function EmergencyWarning({ ack, onAck }) {
  return (
    <div className="rounded-2xl p-6" style={{background:"#FFE2E2", border:"1px solid #F5B5B5"}} data-testid="emergency-warning">
      <div className="flex items-center gap-3 mb-3">
        <AlertTriangle color="#B3261E" strokeWidth={1.8} />
        <h3 className="font-display font-bold text-lg" style={{color:"#B3261E"}}>This is not for emergencies</h3>
      </div>
      <p className="text-sm text-[#5A2626] mb-3">
        Please visit the nearest hospital / emergency immediately if your child has any of these red flags:
      </p>
      <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-1 text-[13px] text-[#5A2626] mb-4 pl-4 list-disc">
        {RED_FLAGS.map((r) => (<li key={r}>{r}</li>))}
      </ul>
      <label className="flex items-start gap-2 text-sm font-medium text-[#5A2626] cursor-pointer">
        <input
          type="checkbox"
          checked={ack}
          onChange={(e) => onAck(e.target.checked)}
          className="mt-1 accent-[#B3261E]"
          data-testid="emergency-ack-checkbox"
        />
        <span>I understand this is not an emergency service.</span>
      </label>
    </div>
  );
}
